import React, {useContext} from "react"
import {buildClassList} from "../helpers/utilities"
import {
  CONTAINER_LG,
  TOP_OFFSET,
  ARROW_UP_KEYCODE,
  ARROW_DOWN_KEYCODE,
  ARROW_LEFT_KEYCODE,
  ARROW_RIGHT_KEYCODE
} from "../helpers/constants"
import SearchField from "../SearchField"
import Plus from "../Icons/Plus"
import Minus from "../Icons/Minus"
import Link from "../Links"
import SiteContext from "../context/SiteContext"

const NavBarItem = ({
  type,
  href,
  children,
  active = false,
  className,
  columnKey,
  columns,
  action,
  placeholder,
  top,
  isOpen,
  navTop,
  ...otherProps
}) => {
  const {site, width, overviewText, toggleNav} = useContext(SiteContext)

  const handelClick = e => {
    e.preventDefault()

    if (isOpen) {
      toggleNav(null)
    } else {
      if (width > CONTAINER_LG) {
        let win = window.open(href, "_self")
        win.focus()
      } else {
        toggleNav(columnKey)
      }
    }
  }

  // ARROW KEY NAVIGATION FOR NAVBAR TABS
  const handleNavTabKeyDown = e => {
    if (e.keyCode === ARROW_LEFT_KEYCODE || e.keyCode === ARROW_RIGHT_KEYCODE || e.keyCode === ARROW_DOWN_KEYCODE) {
      e.preventDefault()

      let tabNumber = parseInt(e.target.id.split('-')[1])
      let nextElement = null

      if (e.keyCode === ARROW_DOWN_KEYCODE) {
        document.getElementById(`list-${tabNumber}-1-1`).focus()
      } else if (e.keyCode === ARROW_LEFT_KEYCODE || e.keyCode === ARROW_UP_KEYCODE) {
        nextElement = document.getElementById(`navBar-${(tabNumber - 1).toString()}`)

        if (nextElement) {
          if(isOpen) {
            toggleNav(null)
            nextElement.focus()
            toggleNav(document.activeElement.id)
          } else {
            nextElement.focus()
          }
        }
      } else if (e.keyCode === ARROW_RIGHT_KEYCODE) {
        nextElement = document.getElementById(`navBar-${(tabNumber + 1).toString()}`)

        if (nextElement && tabNumber !== 28) {
          if(isOpen) {
            toggleNav(null)
            nextElement.focus()
            toggleNav(document.activeElement.id)
          } else {
            nextElement.focus()
          }
        }
      }
    }
  }

  // ARROW KEY NAVIGATION FOR MEGA MENU DROPDOWN
  const handleMegaMenuKeyDown = (e, key) => {
    if (e.keyCode === ARROW_UP_KEYCODE || e.keyCode === ARROW_DOWN_KEYCODE) {
      e.preventDefault()
  
        let keyStringArray = key.split('-')
        let tabNumber = parseInt(keyStringArray[1])
        let columnNumber = parseInt(keyStringArray[2])
        let listItem = parseInt(keyStringArray[3])
        let nextElementId = null
        let nextElement = null

      if (e.keyCode === ARROW_DOWN_KEYCODE) {
        nextElementId = `${keyStringArray[0]}-${tabNumber.toString()}-${columnNumber.toString()}-${(listItem + 1).toString()}`
        
        nextElement = document.getElementById(nextElementId)
  
        if (nextElement) {
          nextElement.focus()
        } else {
          nextElementId = `${keyStringArray[0]}-${tabNumber.toString()}-${(columnNumber + 1).toString()}-${1}`
  
          nextElement = document.getElementById(nextElementId)
  
          if (nextElement) {
            nextElement.focus()
          } else {
            nextElementId = `navBar-${(tabNumber + 1).toString()}`
            nextElement = document.getElementById(nextElementId)
  
            if (nextElement) {
              nextElement.focus()
            }
          }
        }
      } else if (e.keyCode === ARROW_UP_KEYCODE) {

        if (listItem === 1 && columnNumber === 1) {
          nextElement = document.getElementById(`navBar-${tabNumber.toString()}`)

          if(nextElement) {
            nextElement.focus()

            return
          }
        }

        nextElementId = `${keyStringArray[0]}-${tabNumber.toString()}-${columnNumber.toString()}-${(listItem - 1).toString()}`
        
        nextElement = document.getElementById(nextElementId)
  
        if (nextElement) {
          nextElement.focus()
        } else {
          nextElement = document.getElementById(`column-${(tabNumber).toString()}-${(columnNumber - 1).toString()}`).lastChild.getElementsByTagName('a')
  
          if (nextElement) {
            Array.from(nextElement)[0].focus()
          } else {
            nextElementId = `navBar-${(tabNumber - 1).toString()}`
            nextElement = document.getElementById(nextElementId)
  
            if (nextElement) {
              nextElement.focus()
            }
          }
        }
      }
    }
  }

  let ariaLabel = null

  if (isOpen) {
    ariaLabel =
    width > CONTAINER_LG
      ? `${children} menu has additional options and use space bar to close the sub menu or enter to navigate to the page.`
      : `${children} menu has additional options and use space bar to close the sub menu.`
  } else {
    ariaLabel =
    width > CONTAINER_LG
      ? `${children} menu has additional options and use space bar to open the sub menu or enter to navigate to the page.`
      : `${children} menu has additional options and use space bar to open the sub menu.`
  }

  return (
    <li
      onClick={() => {}}
      className={buildClassList([
        "navItem border-b border-blue-600 self-stretch",
        "lg:border-none",
        className,
        type === "search" ? "searchNav flex-grow " : null
      ])}
      {...otherProps}
    >
      {type === "link" && (
        <>
          <Link
            id={columnKey}
            href={href}
            aria-controls={`${columnKey}-column`}
            aria-expanded={isOpen}
            aria-label={ariaLabel}
            onClick={handelClick}
            onKeyDown={(e) => handleNavTabKeyDown(e)}
            className={buildClassList([
              "block w-full px-5 py-3 flex bg-blue-700",
              "lg:focus:bg-gray-400 lg:focus:text-blue-500",
              "lg:hover:bg-gray-400 lg:hover:text-blue-500",
              isOpen && width > CONTAINER_LG
                ? "lg:bg-gray-400 lg:text-blue-500"
                : active
                ? "active lg:bg-blue-600 text-white font-bold"
                : "text-white lg:bg-blue-700"
            ])}
          >
            <span className="flex-grow text-left lg:whitespace-no-wrap text-lg lg:text-base">{children}</span>
            {isOpen ? (
              <Minus className="lg:hidden mt-1minus" focusable="false" />
            ) : (
              <Plus className="lg:hidden mt-1minus" focusable="false" />
            )}
          </Link>
          {columns && (
            <div
              id={`${columnKey}-column`}
              aria-expanded={isOpen}
              aria-hidden={!isOpen}
              role="navigation"
              style={width > CONTAINER_LG ? {top: top + TOP_OFFSET} : {top: 0}}
              className={buildClassList([
                "subMenu w-full h-auto relative top-0 lg:fixed bg-gray-400 w-90 lg:w-screen z-50 lg:left-0 lg:shadow pb-4 lg:pb-0",
                isOpen ? "visible" : "invisible",
                width > CONTAINER_LG
                  ? isOpen
                    ? "visible opacity-100"
                    : "desktop"
                  : isOpen
                  ? "block visible"
                  : "hidden"
              ])}
            >
              
                <div className="container lg:mx-auto mx-0">
                  <div className="lg:flex">
                  <Link href={href} className="lg:hidden py-6 block">
                    <span className="flex-grow text-left text-blue-500 font-bold hover:underline hover:text-blue-600">
                      {overviewText}
                    </span>
                  </Link>
                  {columns.map((column) => {
                    return (
                      <div
                        key={column.key}
                        className="lg:flex flex-row lg:flex-col flex-1 lg:py-6 lg:pr-6"
                        id={column.key}
                      >
                        {column.name === "&nbsp;" && width > CONTAINER_LG && <div style={{marginBottom: ".5em"}}>&nbsp;</div>}
                        {column.name !== "&nbsp;" && (
                          <h2 className={buildClassList([
                            "text-black uppercase font-bold",
                            column.name && "pb-2"
                          ])}>
                            {column.name}
                          </h2>
                        )}
                        {column.list.map(item => {
                          const { key, text, href, subText } = item
                          return (
                            <div key={key} className="pb-1 lg:pb-3">
                              <Link
                                id={key}
                                onKeyDown={e => handleMegaMenuKeyDown(e, key)}
                                href={href}
                                external={false}
                                className={buildClassList([
                                  "mt-0 mb-4 block text-blue-500 font-bold",
                                  "lg:mt-1 lg:mb-0",
                                  "hover:underline hover:text-blue-600",
                                  "focus:text-blue-600",
                                  subText ? "lg:mt-1" : "lg:mt-1"
                                ])}
                              >
                                {text}
                              </Link>
                              {subText && (
                                <p className="text-black hidden lg:block">
                                  {subText}
                                </p>
                              )}
                            </div>
                          )
                        })}
                      </div>
                    )
                  })}
                  </div>

                </div>
              </div>
          )}
        </>
      )}

      {type === "search" && (
        <SearchField
          id={columnKey}
          formID="navBarSearchForm"
          buttonId="navBarSearchButton"
          className={buildClassList([
            "hidden mt-2-5 h-6 mb-2-5 w-full ml-auto",
            site.search.show ? "block" : ""
          ])}
          style={{maxWidth: "250px", maxHeight: "24px", lineHeight: "18px"}}
          placeholder={site.search.placeholder}
          action={site.search.action}
          external={site.search.external}
          label={site.search.label}
          btnLabel={site.search.btnLabel}

        />
      )}
    </li>
  )
}

export default NavBarItem
